export default {
  countries: {
    'The Kingdom of Bahrain': '🇧🇭 البحرين',
    'The Arab Republic of Egypt': '🇪🇬 مصر',
    'The State of Kuwait': '🇰🇼 الكويت',
    'Sultanate of Oman': '🇴🇲 عمان',
    'The State of Qatar': '🇶🇦 قطر',
    'Kingdom of Saudi Arabia': '🇸🇦 السعودية',
    'The United Arab Emirates': '🇦🇪 الإمارات'
  },
  labels: {
    selectCountry: 'اختر الدولة',
    chooseLanguage: 'اختر اللغة',
    searchStores: 'البحث عن متجر..',
    recent: 'البحوث السابقة',
    clearAll: 'مسح الكل',
    noCodesFound: 'لم يتم العثور على رموز',
    contactUs: 'اتصل بنا'
  },
  categories: {
    all: 'الكل',
    abaya: 'عبايات',
    babies: 'اطفال',
    beauty: 'جمال',
    bookings: 'حجوزات',
    cars: 'سيارات',
    coffeeAndSweets: 'قهوة وحلا',
    delivery: 'توصيل',
    electronics: 'الإلكترونيات',
    fashion: 'الأزياء',
    flowers: 'ورد',
    furniture: 'اثاث',
    games: 'ألعاب',
    gifts: 'هدايا',
    groceries: 'مواد غذائية',
    health: 'صحة',
    home: 'المنزل',
    jewelry: 'مجوهرات',
    oud: 'العود',
    perfumes: 'عطور',
    pet: 'اليف',
    restaurants: 'مطاعم',
    services: 'خدمات',
    shoes: 'الأحذية',
    sports: 'رياضة',
    water: 'مياه'
  },
  actions: {
    copied: 'تم نسخ الكود!',
    copy_code: 'نسخ الرمز'
  },
  landing: {
    heroTitle: 'وفّر في كل مرة تتسوق',
    heroDescription: 'بلوبون هو أول مجتمع للكوبونات في الشرق الأوسط.\nاكتشف أحدث كوبونات الخصم المعتمدة لمئات المتاجر الإلكترونية.',
    downloadPrompt: 'حمّل التطبيق اليوم!'
  }
  ,
  savings: {
    sectionTitle: 'رفيقك اليومي للتوفير',
    cards: [
      {
        title: 'آلاف الكوبونات',
        description: 'آلاف الكوبونات، مئات المتاجر، وتحديثات يومية.'
      },
      {
        title: 'مدعوم من المجتمع',
        description: 'شارك الكوبونات الخاصة بك وساعد الجميع على التوفير.'
      },
      {
        title: 'نسخ بضغطة واحدة',
        description: 'استخدم الكوبون قبل الدفع.'
      },
      {
        title: 'احفظ المفضلات',
        description: 'تابع المتاجر المفضلة لديك ولا تفوت أي خصم.'
      },
      {
        title: 'إشعارات ذكية',
        description: 'احصل على إشعارات عندما تتوفر قسائم جديدة لمتاجرك المفضلة.'
      }
    ]
  },
  steps: {
    sectionTitle: 'تسوق بذكاء في 3 خطوات سهلة',
    cards: [
      {
        title: 'اكتشف عروض يمكنك الوثوق بها',
        description: 'استكشف أحدث كوبونات الخصم المعتمدة لمتاجرك المفضلة.'
      },
      {
        title: 'انسخ والصق على الفور',
        description: 'وجدت كود خصم؟ اضغط مرة واحدة لنسخه واستخدامه مباشرة عند الدفع.'
      },
      {
        title: 'شارك وساعد الآخرين على التوفير',
        description: 'انشر كوبونات الخصم الخاصة بك وازدهر مجتمع التوفير في بلوبون.'
      }
    ]
  },
  graphics: {
    items: [
      { title: 'عروض محلية', description: 'ابحث عن كوبونات الخصم لمتاجرك المفضلة' },
      { title: 'معتمدة من المجتمع', description: 'شاهد تقييمات من متسوقين حقيقيين' },
      { title: 'سريع وسهل', description: 'انسخ كود الخصم بضغطة واحدة' }
    ]
  ,
  sectionTitle: 'أسهل طريقة للتوفير في الشرق الأوسط'
  }
  ,
  built: {
    sectionTitle: 'بنيت من قبل المتسوقين، للمتسوقين',
    items: [
      { number: '50,000+', title: 'تم توفيرها من قبل مستخدمي بلوبون' },
      { number: '6+', title: 'دول في الشرق الأوسط، بما في ذلك: المملكة العربية السعودية، الإمارات العربية المتحدة، مصر والمزيد' },
      { number: '2,000+', title: 'كوبونات لمئات المتاجر\nوالعلامات التجارية عبر الإنترنت' }
    ],
    cta: 'ابدأ اليوم!\u200F'
  },
  feature: {
    title: 'حمّل تطبيق بلوبون',
    description: 'انضم إلى أول مجتمع للكوبونات في الشرق الأوسط وابدأ التوفير. قم بتحميل تطبيق بلوبون واكتشف آلاف القسائم المعتمدة لمئات المتاجر الإلكترونية.',
    downloadLabel: 'قم بالتنزيل على',
    followLabel: 'تابعنا على وسائل التواصل الاجتماعي',
    terms: 'الشروط والأحكام',
    privacy: 'سياسة الخصوصية'
  }
};